// extracted by mini-css-extract-plugin
export default {"imageMedia":"imageMedia-Ebqlm","placeholder":"placeholder-vXE1j"};